import Walter from "../../../../docs/_images/walter.png";
import * as React from 'react';
export default {
  Walter,
  React
};